export const postMethod = (url, Object) => {
  //console.log(url, Object);
  return fetch(url, {
    method: "POST",

    headers: {
      "access-control-allow-origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json",
      APIKey: "D3AbRzseS692XIi03Gc/aJeXPH4DH4cJ8ieciDdBaBo=",
    },
    body: Object,
  })
    .then((response) => response.json())
    .then((responseData) => {
      return responseData;
    })
    .catch((error) => console.warn(error));
};
